import { HttpClient, HttpHeaders } from '@angular/common/http';

import { PagedResult } from '../../@AppService/Models/PagedResult';
import { SelectItems, listKeyitem } from '../../@AppService/Models/SelectItems';

import { Observable } from 'rxjs';
import { authenticationService } from './authenticationService';
import { QueryModel } from '../../@AppService/Models/queryModel';
import { environment } from '../../../environments/environment';
import { serviceDetails } from '../Models/service-details';

export class BaseService {
  headers = new HttpHeaders();
  constructor(
    public http: HttpClient,
    private authenticationSerives: authenticationService,
    private url: string,
  ) {
    // this.authenticationSerives.createAuthorizationHeader();
    // this.headers = this.authenticationSerives.headers;
  }
  get(queryModel: QueryModel, url: string = ''): Observable<PagedResult> {
    return this.http.get<PagedResult>(this.url + url, {
      params: {
        currentPage: queryModel.currentPage.toString(),
        pageSize: queryModel.pageSize.toString(),
        sort: queryModel.sort,
        sortDirection: queryModel.sortDirection,
        searchTerm: queryModel.searchTerm,
      },
      headers: this.getAuthorizationHeader(),
    });
  }

  search(
    queryModel: QueryModel,
    currentPage: number,
    pageSize: number,
    url: string = 'search',
  ): Observable<PagedResult> {
    url = environment.apiUrl + url;
    return this.http.get<PagedResult>(url, {
      params: {
        currentPage: currentPage.toString(),
        pageSize: pageSize.toString(),
        sort: queryModel.sort,
        sortDirection: queryModel.sortDirection,
        searchTerm: queryModel.searchTerm,
        ...(queryModel.modelName ? { modelName: queryModel.modelName } : {}),
      },
      headers: this.getAuthorizationHeader(),
    });
  }

  getApi(route: string) {
    return this.http.get<PagedResult>(this.url + '/' + route, {
      headers: this.getAuthorizationHeader(),
    });
  }

  getData(route: string) {
    return this.http.get<any>(this.url + '/' + route, {
      headers: this.getAuthorizationHeader(),
    });
  }

  getAll(queryModel: QueryModel, domain: string): Observable<PagedResult> {
    return this.http.get<PagedResult>(this.url + domain, {
      params: {
        currentPage: queryModel.currentPage.toString(),
        pageSize: queryModel.pageSize.toString(),
        sort: queryModel.sort,
        sortDirection: queryModel.sortDirection,
        searchTerm: queryModel.searchTerm,
      },
      headers: this.getAuthorizationHeader(),
    });
  }

  getById(id: number): Observable<serviceDetails> {
    return this.http.get<serviceDetails>(this.url + '/' + id, {
      headers: this.getAuthorizationHeader(),
    });
  }

  post(object: any, url: string = '') {
    return this.http.post<any>(this.url + url, object, {
      headers: this.getAuthorizationHeader(),
    });
  }

  delete(id: number) {
    return this.http.delete(this.url + '/' + id, {
      headers: this.getAuthorizationHeader(),
    });
  }

  put(id: number, object: any) {
    return this.http.put(this.url + '/' + id, object, {
      headers: this.getAuthorizationHeader(),
    });
  }

  getCreate() {
    return this.http.get<SelectItems[]>(this.url + '/Create', {
      headers: this.getAuthorizationHeader(),
    });
  }

  getCreateNew() {
    return this.http.get<listKeyitem[]>(this.url + '/Create', {
      headers: this.getAuthorizationHeader(),
    });
  }

  uploadFile(files: any) {
    return this.http.post<any>(
      environment.apiUrl + 'UploadFile/Upload',
      files,
      { headers: this.getAuthorizationHeader() },
    );
  }

  uploadMultipleFiles(files: any) {
    return this.http.post<any>(
      environment.apiUrl + 'UploadFile/UploadMultiple',
      files,
      {
        headers: this.getAuthorizationHeader(),
      },
    );
  }

  saveFile(object: any) {
    return this.http.post(environment.apiUrl + 'UploadFile/SaveFile', object);
  }

  getAuthorizationHeader() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem('e-serviceToken'),
        'Content-Type': 'application/json',
      });
    } else return new HttpHeaders();
  }

  downloadFile(filename: string) {
    return this.http.post(
      environment.apiUrl + 'UploadFile/Download',
      { filename: filename },
      {
        headers: this.getAuthorizationHeader(),
        responseType: 'blob' as 'json',
      },
    );
  }
}
